import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

import bannergame from '../assest/products/extra/bannergame.jpg';
import bannergameMobile from '../assest/products/extra/m1.webp';

import bannerrefurbished from '../assest/products/extra/bannerrefurbished.webp';
import bannerrefurbishedMobile from '../assest/products/banner/m1.png';

import bannerbusiness from '../assest/products/banner/banner5.webp';
import bannerbusinessMobile from '../assest/products/banner/m2.png';

import bannerlap from '../assest/products/extra/bannerlap.png';
import bannerlapMobile from '../assest/products/extra/m2.avif';

import banner from '../assest/products/extra/banner.jpg';
import bannerMobile from '../assest/products/banner/m3.png';

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const BannerCarousel = () => {

  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);

  // 🔥 detect screen size
  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const banners = [
    {
      desktop: banner,
      mobile: bannerMobile,
      link: "/product-category?"
    },
    {
      desktop: bannergame,
      mobile: bannergameMobile,
      link: "/product-category?category=gaming"
    },
    {
      desktop: bannerbusiness,
      mobile: bannerbusinessMobile,
      link: "/product-category?category=business"
    },
    {
      desktop: bannerlap,
      mobile: bannerlapMobile,
      link: "/product-category?category=2in1"
    },
    {
      desktop: bannerrefurbished,
      mobile: bannerrefurbishedMobile,
      link: "/product-category?brand=apple"
    }
  ];

  return (
    <div className="w-full">

      <Swiper
        modules={[Autoplay, Pagination, Navigation]}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop
        pagination={{ clickable: true }}
        navigation
        className={`
          w-full 
          ${isMobile 
            ? "h-[78vh]"   // 🔥 mobile full screen feel
            : "aspect-[16/6] lg:aspect-[16/7]"
          }
        `}
      >
 
        {banners.map((banner, index) => (
          <SwiperSlide key={index}>

            <div
              onClick={() => navigate(banner.link)}
              className="relative w-full h-full cursor-pointer overflow-hidden group"
            >

              {/* 🔥 IMAGE SWITCH */}
              <motion.img
                key={isMobile ? banner.mobile : banner.desktop}
                src={isMobile ? banner.mobile : banner.desktop}
                initial={{ scale: 1.1, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.8 }}
                className="w-full h-full object-cover object-center"
              />

              {/* 🔥 HOVER ZOOM */}
              <div className="absolute inset-0 transition-transform duration-700 group-hover:scale-105" />


              {/* 🔥 CONTENT ANIMATION */}
              <div className="absolute inset-0 flex items-center">

                <div className="container mx-auto px-4 md:px-10 text-white max-w-xl">


                </div>

              </div>

            </div>

          </SwiperSlide>
        ))}

      </Swiper>

    </div>
  );
};

export default BannerCarousel;

